module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('entity-page', {
    directives: [{
      name: "loader-overlay",
      rawName: "v-loader-overlay",
      value: (_vm.progress),
      expression: "progress"
    }],
    attrs: {
      "id": "page__status-reason"
    }
  }, [_c('template', {
    slot: "header-right"
  }, [_c('z-icon-button', {
    attrs: {
      "icon": ['fa', 'xmark'],
      "danger-light": "",
      "rounded": ""
    },
    on: {
      "click": _vm.back
    }
  }), _vm._v(" "), _c('z-icon-button', {
    attrs: {
      "icon": ['fa', 'check'],
      "success-light": "",
      "rounded": ""
    },
    on: {
      "click": _vm.save
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('z-select', _vm._b({
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    staticClass: "col-6",
    model: {
      value: (_vm.reason.status_id),
      callback: function($$v) {
        _vm.$set(_vm.reason, "status_id", $$v)
      },
      expression: "reason.status_id"
    }
  }, 'z-select', {
    id: 'status_id',
    name: 'status_id',
    label: 'Статус',
    'data-vv-as': ' ',
    'data-vv-name': 'status_id',
    error: _vm.errors.first('status_id')
  }, false), [_c('option', {
    attrs: {
      "value": "",
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v("Не укстановлен")]), _vm._v(" "), _vm._l((_vm.statuses), function(statuse) {
    return _c('option', {
      domProps: {
        "value": statuse.id
      }
    }, [_vm._v(" " + _vm._s(statuse.name) + " ")])
  })], 2), _vm._v(" "), _c('z-select', _vm._b({
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    staticClass: "col-6",
    model: {
      value: (_vm.reason.comment_require),
      callback: function($$v) {
        _vm.$set(_vm.reason, "comment_require", $$v)
      },
      expression: "reason.comment_require"
    }
  }, 'z-select', {
    label: 'Обязательность комментария при установке статуса',
    id: 'comment_require',
    name: 'comment_require',
    'data-vv-as': ' ',
    'data-vv-name': 'comment_require',
    error: _vm.errors.first('comment_require')
  }, false), [_c('option', {
    attrs: {
      "value": "",
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v("Не укстановленно")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("Нет")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("Да")])]), _vm._v(" "), _c('z-input', _vm._b({
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        min: 4,
        max: 255
      }),
      expression: "{required: true, min: 4, max: 255}"
    }],
    staticClass: "col-6",
    model: {
      value: (_vm.reason.name),
      callback: function($$v) {
        _vm.$set(_vm.reason, "name", $$v)
      },
      expression: "reason.name"
    }
  }, 'z-input', {
    name: 'name',
    id: 'name',
    label: 'Название',
    'data-vv-name': 'name',
    'data-vv-as': ' ',
    error: _vm.errors.first('name')
  }, false)), _vm._v(" "), _c('z-input', _vm._b({
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        min: 4,
        max: 255
      }),
      expression: "{required: true, min: 4, max: 255}"
    }],
    staticClass: "col-6",
    model: {
      value: (_vm.reason.code),
      callback: function($$v) {
        _vm.$set(_vm.reason, "code", $$v)
      },
      expression: "reason.code"
    }
  }, 'z-input', {
    id: 'code',
    name: 'code',
    label: 'Символьный уникальный код',
    'data-vv-name': 'code',
    'data-vv-as': ' ',
    error: _vm.errors.first('code')
  }, false))], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31c9618e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/deals/views/StatusReason.vue
// module id = 1102
// module chunks = 0